import React from 'react';

const File = ({name, url, size, ext}) => {
    const fileSize = formatBytes(size);
    return (
        <div className="file-container">
            <h6><a href={url}>{name}</a></h6>
            <div className="file-ext">{ext} Document</div>
            <div className="file-size">{fileSize}</div>
        </div> 
        );
}


//turn bytes into readable formats
function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

export default File;